var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"campaigns-list"},[_c('CampaignHeaders'),_vm._l((_vm.campaignsData),function(campaign,index){return _c('CampaignElement',{key:campaign.id,attrs:{"last-element":_vm.campaignsData.length > 1 && index === _vm.campaignsData.length - 1,"campaign":campaign}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }